module.exports = __webpack_public_path__ + "img/community.4fc7f9c7.png";